const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const hasFrenchHours = (item) => {
  const title = `${item?.title || ''} ${item?.name || ''} ${item?.prefix || ''}`;
  return !title.toLowerCase().includes('sov');
};

export const getShoppingCenterViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const fields = [
    { text: t('Titolo'), value: display(item.title) },
    { text: t('Loyalty url'), value: display(item.loyalty_url) },
    { text: t('Prefix'), value: display(item.prefix) },
    {
      text: t('Mappa extrastock'),
      key: 'extrastock_map',
      value: item.extrastock_map,
    },
    {
      text: t('Privacy Career - uso candidati'),
      value: display(item.privacy_candidate),
    },
    {
      text: t('Privacy Career - uso tenants'),
      value: display(item.privacy_company),
    },
    { text: t('Smart shopping path'), value: display(item.cc_path) },
    { text: t('Smart shopping auth path'), value: display(item.cc_auth_path) },
    { text: t('Smart shopping token'), value: display(item.cc_token) },
    {
      text: `${t('Orari di Lavoro')} IT`,
      value: display(item.working_hours_it),
    },
    {
      text: `${t('Orari di Lavoro')} EN`,
      value: display(item.working_hours_en),
    },
  ];

  if (hasFrenchHours(item)) {
    fields.push({
      text: `${t('Orari di Lavoro')} FR`,
      value: display(item.working_hours_fr),
    });
  }

  return [
    {
      title: t('SHOPPING CENTER'),
      fields,
    },
  ];
};
